import { render, staticRenderFns } from "./HomeUpdates.vue?vue&type=template&id=2686dd75"
import script from "./HomeUpdates.vue?vue&type=script&lang=js"
export * from "./HomeUpdates.vue?vue&type=script&lang=js"
import style0 from "./HomeUpdates.vue?vue&type=style&index=0&id=2686dd75&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports